'use client';

import React from 'react';

import { getResponsiveContentfulImageUrl, progressiveJpegOptions } from '@/ui';
import { ISiteSectionEntry } from '@move-frontend/contentful';
import {
	IPageLayoutProps,
	PageLayout,
} from '../../../shared/layout/page/PageLayout';
import Header from '../../../../components/common/header/Header';
import { useCommonData } from '../../../../common-data/useCommonData';
import { getUrlForPage } from '../../../../navigation/getUrlForPage';
import { INewsItemEntry } from '../../../../contentful/types/INewsItemEntry';
import { IBlogItemEntry } from '../../../../contentful/types/IBlogItemEntry';
import EntryItemContentPage from './EntryItemContentPage';
import { IPageEntry } from '../../../../contentful/types/IPage';

export interface IGenericEntryPageProps extends IPageLayoutProps {
	page: IPageEntry;
	data: INewsItemEntry | IBlogItemEntry;
	siteSection?: ISiteSectionEntry;
}

export default function GenericEntryPage({
	page,
	data,
	siteSection,
	...rest
}: IGenericEntryPageProps) {
	const { pathToPageIdMap } = useCommonData();

	return (
		<PageLayout {...rest}>
			<Header
				siteSection={siteSection}
				backgroundImage={
					data.fields.image?.fields.file.url
						? getResponsiveContentfulImageUrl(
								data.fields.image.fields.file.url,
								{
									...progressiveJpegOptions,
								},
						  )
						: undefined
				}
				title={data.fields.title}
				backLink={getUrlForPage(pathToPageIdMap, page.fields.id)}
			/>

			<EntryItemContentPage data={data} />
		</PageLayout>
	);
}
